export default {
  setEngagementQueueRules(state, payload) {
    state.engagementQueueRules = payload;
  },
  setEngagementQueueRuleDetail(state, payload) {
    state.engagementQueueRuleDetail = payload;
  },
  setEngagementQueueRuleTags(state, payload) {
    state.engagementQueueRuleTags = payload;
  },
  setWorksaceGroupIsStorm(state, payload) {
    state.worksaceGroupIsStorm = payload;
  },
  setFeedQueueAssignment(state, payload) {
    state.feedQueueAssignment = payload;
  },

  
};
